<template>
  <div>
    <v-row v-if="showLocIdInput" class="mt-6">
      <v-col
        cols="12"
        v-if="
          ($route.path === '/' || $route.path === '/nbn-orders') &&
            !sqResult.correlationId &&
            queryAddress.length > 1
        "
        class="pb-0"
      >
        <p class="red--text mb-0">
          *SQ result is required. Select location ID then click Run NBN SQ.
        </p>
      </v-col>
      <v-col
        cols="12"
        :sm="fieldColSize"
        :class="$vuetify.breakpoint.xs ? 'pb-0 mb-0' : ''"
        v-if="hasMatch"
      >
        <ValidationProvider
          v-slot="{ errors }"
          name="Location ID"
          rules="required|alpha_num|loc_id_length:15|locationId"
        >
          <v-autocomplete
            v-if="
              (queryAddress.length > 1 || addresses.length > 1) && !isOriginal
            "
            outlined
            :items="sortedQueryAddress"
            label="Select Location ID"
            v-model="nbnOrder.locationId"
            :item-text="locationText"
            item-value="locationId"
            :error-messages="errors"
            :clearable="!isOriginal"
            @change="updateLocationId"
            :readonly="isOriginal"
            @click:clear="clearLocId()"
          >
          </v-autocomplete>
          <v-text-field
            v-else-if="!isOriginal"
            label="Location ID"
            v-model="nbnOrder.locationId"
            @change="updateLocId"
            outlined
            :error-messages="errors"
            :clearable="!isOriginal"
            autocomplete="off"
            maxlength="15"
            @update:error="disableSqButton"
            :readonly="isOriginal"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col v-else class="red--text font-weight-bold" cols="12">
        No matching addresses found.
      </v-col>

      <v-col v-if="!hasMatch" cols="12">
        <address-check @showAddresses="showAddresses"></address-check>
      </v-col>

      <v-col
        cols="12"
        :sm="fieldColSize"
        :class="$vuetify.breakpoint.xs ? 'pb-0 mb-0' : ''"
        v-if="isEnhancedTransition"
      >
        <ValidationProvider v-slot="{ errors }" name="POTS Interconnect">
          <v-text-field
            label="POTS Interconnect"
            v-model="potsInterconnect"
            outlined
            :error-messages="errors"
            :clearable="!isOriginal"
            autocomplete="off"
            maxlength="15"
            :readonly="isOriginal"
            :disabled="isPendingServiceability"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col
        cols="12"
        :sm="fieldColSize"
        :class="$vuetify.breakpoint.xs ? 'pb-0 mb-0' : ''"
        v-if="isEnhancedTransfer"
      >
        <ValidationProvider
          name="Service Id"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            label="Service Id"
            v-model="serviceId"
            outlined
            :error-messages="errors"
            :clearable="!isOriginal"
            autocomplete="off"
            maxlength="15"
            :readonly="isOriginal"
            :disabled="isPendingServiceability"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col cols="12" :md="'6'" class="pt-0 pb-1" v-if="isEnhancedTransfer">
        <ValidationProvider
          name="Customer Authority Date"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="cad"
                label="Customer Authority Date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="cad" @input="menu = false"></v-date-picker>
          </v-menu>
        </ValidationProvider>
      </v-col>
      <v-col
        cols="12"
        :sm="buttonColSize"
        :class="$vuetify.breakpoint.xs ? 'pt-0 mb-4' : ''"
        v-if="showNbnButton"
      >
        <v-btn
          v-if="showNbnButton"
          class="primary"
          :class="$vuetify.breakpoint.xs ? 'mt-0' : 'mt-2'"
          width="100%"
          large
          :disabled="
            !nbnOrder.locationId ||
              disableButton ||
              isOriginal ||
              (!isTransferReady && isEnhancedTransfer)
          "
          @click="runNBNSQ()"
          >Run NBN SQ</v-btn
        >
      </v-col>
    </v-row>
    <div style="overflow-x: auto" v-if="showSqResult">
      <div
        v-for="panel in sqResultPanels"
        :key="panel.key"
        class="custom-div mb-6"
        :class="panelBorderClass(panel)"
      >
        <app-heading :text="panel.title" :heading="'main'"></app-heading>
        <v-btn
          @click="copyText(panel.key)"
          class="primary mb-5"
          :disabled="isOriginal"
          >Copy Result</v-btn
        >
        <div :ref="'sqResult-' + panel.key">
          <div v-if="panel.empty">
            <div class="font-weight-bold">{{ panel.emptyText }}</div>
            <div v-if="panel.emptyMessage">{{ panel.emptyMessage }}</div>
          </div>
          <div v-else>
            <div v-if="panel.key !== 'ee'">
              <div
                class="text-right py-0 pr-0 mr-3 font-weight-bold"
                :class="addClass"
                style="display: inline-block"
              >
                Address:
              </div>
              <div
                class="pl-0 py-0"
                style="display: inline-block"
                :style="$route.path === '/' ? 'width: 59%;' : 'width: 60%;'"
              >
                <span v-html="tier1"></span>{{ newAddress }}
              </div>
            </div>

            <div v-if="panel.key !== 'ee'">
              <p class="custom-p text-right font-weight-bold" :class="addClass">
                NBN Co Location ID:
              </p>
              <p class="custom-p">
                <span v-html="tier1"></span
                >{{
                  sqNbnResult.address && sqNbnResult.address.id
                    ? sqNbnResult.address.id
                    : nbnOrder.locationId
                }}
              </p>
            </div>

            <template v-if="panel.key === 'ee'">
              <div
                v-for="(section, sectionIndex) in panel.formatted.sections"
                :key="section.title"
              >
                <div
                  v-if="eeRows(section).length"
                  :class="sectionIndex > 0 ? 'mt-4 pt-4 row-border' : ''"
                >
                  <div
                    v-for="item in eeRows(section)"
                    :key="section.title + item.name"
                  >
                    <div
                      class="text-right py-0 pr-0 mr-3 font-weight-bold"
                      :class="addClass"
                      style="display: inline-block"
                    >
                      {{ `${item.name}:` }}
                    </div>
                    <div
                      class="pl-0 py-0"
                      style="display: inline-block"
                      :style="$route.path === '/' ? 'width: 59%;' : 'width: 40%;'"
                    >
                      <span v-html="tier1"></span>{{ item.value }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-4 pt-4 row-border">
                <div>
                  <div
                    class="text-right py-0 pr-0 mr-3 font-weight-bold"
                    :class="addClass"
                    style="display: inline-block"
                  >
                    NBN Co Location ID:
                  </div>
                  <div
                    class="pl-0 py-0"
                    style="display: inline-block"
                    :style="$route.path === '/' ? 'width: 59%;' : 'width: 40%;'"
                  >
                    <span v-html="tier1"></span>{{
                      sqNbnResult.address && sqNbnResult.address.id
                        ? sqNbnResult.address.id
                        : nbnOrder.locationId
                    }}
                  </div>
                </div>
                <div>
                  <div
                    class="text-right py-0 pr-0 mr-3 font-weight-bold"
                    :class="addClass"
                    style="display: inline-block"
                  >
                    Address:
                  </div>
                  <div
                    class="pl-0 py-0"
                    style="display: inline-block"
                    :style="$route.path === '/' ? 'width: 59%;' : 'width: 60%;'"
                  >
                    <span v-html="tier1"></span>{{ newAddress }}
                  </div>
                </div>
                <div>
                  <div
                    class="text-right py-0 pr-0 mr-3 font-weight-bold"
                    :class="addClass"
                    style="display: inline-block"
                  >
                    Address Latitude &amp; Longitude:
                  </div>
                  <div
                    class="pl-0 py-0"
                    style="display: inline-block"
                    :style="$route.path === '/' ? 'width: 59%;' : 'width: 40%;'"
                  >
                    <span v-html="tier1"></span>{{ panel.formatted.latitude }},
                    {{ panel.formatted.longitude }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
            <div>
              <div
                class="text-right py-0 pr-0 mr-3 font-weight-bold"
                :class="addClass"
                style="display: inline-block"
              >
                Service Class:
              </div>
              <div
                class="pl-0 py-0 font-weight-bold"
                style="display: inline-block"
                :style="$route.path === '/' ? 'width: 59%;' : 'width: 40%;'"
              >
                <span v-html="tier1"></span
                >{{
                  setValue(
                    panel.formatted.serviceabilityClass,
                    panel.formatted.serviceability
                  )
                }}
              </div>
              <span v-html="tier1"></span>
            </div>

            <div :class="!panel.isPending ? 'mb-6' : ''">
              <div
                class="text-right py-0 pr-0 mr-3 font-weight-bold"
                :class="addClass"
                style="display: inline-block"
              >
                Primary Access Technology:
              </div>
              <div
                class="pl-0 py-0 font-weight-bold"
                style="display: inline-block"
                :style="$route.path === '/' ? 'width: 59%;' : 'width: 40%;'"
              >
                <span v-html="tier1"></span
                >{{
                  panel.formatted.accessTechnology
                    ? panel.formatted.accessTechnology
                    : orderDetails.accessTechnology
                }}
              </div>
            </div>

            <div class="mb-6" v-show="panel.isPending">
              <div
                class="text-right py-0 pr-0 mr-3 font-weight-bold"
                :class="addClass"
                style="display: inline-block"
              >
                Planned Serviceability Date:
              </div>
              <div
                class="pl-0 py-0 font-weight-bold"
                style="display: inline-block"
                :style="$route.path === '/' ? 'width: 59%;' : 'width: 40%;'"
              >
                <span v-html="tier1"></span
                >{{ panel.formatted.serviceabilityDate }}
              </div>
            </div>

            <div>
              <p class="custom-p text-right font-weight-bold" :class="addClass">
                CSA Id:
              </p>
              <p class="custom-p">
                <span v-html="tier1"></span
                >{{
                  panel.formatted.csaid
                    ? panel.formatted.csaid
                    : orderDetails.csaid
                }}
              </p>
            </div>

            <div>
              <p class="custom-p text-right font-weight-bold" :class="addClass">
                Address Latitude &amp; Longitude:
              </p>
              <p class="custom-p">
                <span v-html="tier1"></span
                >{{
                  panel.formatted.latitude
                    ? panel.formatted.latitude
                    : orderDetails.latitude
                }},
                {{
                  panel.formatted.longitude
                    ? panel.formatted.longitude
                    : orderDetails.longitude
                }}
              </p>
            </div>

            <div>
              <p class="custom-p text-right font-weight-bold" :class="addClass">
                Region:
              </p>
              <p class="custom-p">
                <span v-html="tier1"></span
                >{{
                  !isOldOrder ? panel.formatted.region : sqNbnResult.Region
                }}
              </p>
            </div>

            <div
              v-for="(item, index) in isOldOrder &&
              sqNbnResult.parameters
                ? sqNbnResult.parameters.parameter
                : panel.nfas"
              :key="item.name + index"
            >
              <p class="custom-p text-right font-weight-bold" :class="addClass">
                {{ `${item.name}:` }}
              </p>
              <p class="custom-p">
                <span v-html="tier1"></span>{{ item.value }}
              </p>
            </div>

            <div
              v-if="
                !isOldOrder &&
                  panel.sq &&
                  panel.sq.siteRestriction &&
                  panel.sq.siteRestriction.supportingTechnology
              "
            >
              <p class="custom-p text-right font-weight-bold" :class="addClass">
                Alternate Technology:
              </p>
              <p class="custom-p">
                <span v-html="tier1"></span
                >{{
                  panel.sq.siteRestriction.supportingTechnology
                    .alternativeTechnology
                }}
              </p>
            </div>

            <div
              v-if="
                !isOldOrder &&
                  panel.sq &&
                  panel.sq.siteRestriction &&
                  panel.sq.siteRestriction.supportingResource &&
                  panel.sq.siteRestriction.supportingResource.length ==
                    0 &&
                  panel.isCopperAccess
              "
              class="mt-4 pt-4 row-border"
            >
              <p class="custom-p text-right font-weight-bold" :class="addClass">
                Copper pairs at this location:
              </p>
              <p class="custom-p">
                <span v-html="tier1"></span>No known copper pairs currently
                listed at this location
              </p>
            </div>

            <div
              v-if="
                !isOldOrder &&
                  panel.sq &&
                  panel.sq.siteRestriction &&
                  panel.sq.siteRestriction.supportingResource
              "
            >
              <div v-for="(item, index) in panel.sq.siteRestriction
                  .supportingResource"
                   :key="index"
                   class="mt-4 pt-4 row-border">
                <div v-if="item.id != null">
                  <p class="custom-p text-right font-weight-bold"
                     :class="addClass">
                    {{ panel.hasNtd ? "NTD ID:" : "Copper Pair ID:" }}
                  </p>
                  <p v-if="item.serviceIDMatch" class="custom-p">
                    <span v-html="tier1"></span>{{ item.id }}(Matched)
                  </p>
                  <p v-else class="custom-p">
                    <span v-html="tier1"></span>{{ item.id }}
                  </p>
                </div>

                <div v-if="item.POTSInterconnectMatch != null">
                  <p class="custom-p text-right font-weight-bold"
                     :class="addClass">
                    POTSInterconnectMatch
                  </p>
                  <p class="custom-p">
                    <span v-html="tier1"></span>{{ item.POTSInterconnectMatch }}
                  </p>
                </div>

                <div v-if="showSection(item, 'cpiDetails')"
                     style="margin: 10px 0">
                  <div v-for="(item, index) in item.cpiDetails"
                       :key="item.name + index">
                    <p class="custom-p text-right font-weight-bold"
                       :class="addClass">
                      {{ `${item.name}:` }}
                    </p>
                    <p class="custom-p">
                      <span v-html="tier1"></span>{{ item.value }}
                    </p>
                  </div>
                </div>

                <div v-if="showSection(item, 'uniPortD')"
                     style="margin: 10px 0">
                  <div class="text-right py-0 pr-0 mr-3 font-weight-bold"
                       :class="addClass">
                    Data, UNI-D:
                  </div>
                  <div class="pl-0 py-0" style="display: inline-block">
                    <div v-for="(subItem, index) in item.uniPortD" :key="index">
                      <span v-html="tier1"></span>
                      <p v-if="subItem.serviceIDMatch"
                         style="width: 160px; display: inline-block"
                         class="mb-0">
                        {{
                          getPortNumber(subItem)
                        }}<span class="text-matched font-weight-bold">
                          <b>(Matched)</b>
                        </span>
                      </p>
                      <p v-else
                         style="width: 160px; display: inline-block"
                         class="mb-0">
                        {{ getPortNumber(subItem) }}
                      </p>
                      <span v-html="tier2"></span>{{ subItem.status }}
                    </div>
                  </div>
                </div>

                <div v-if="showSection(item, 'uniPortV')"
                     style="margin: 10px 0">
                  <div class="text-right py-0 pr-0 mr-3 font-weight-bold"
                       :class="addClass">
                    Voice, UNI-V:
                  </div>
                  <div class="pl-0 py-0" style="display: inline-block">
                    <div v-for="(subItem, index) in item.uniPortV" :key="index">
                      <span v-html="tier1"></span>
                      <p style="width: 160px; display: inline-block"
                         class="mb-0">
                        {{ getPortNumber(subItem) }}
                      </p>
                      <span v-html="tier2"></span>{{ subItem.status }}
                    </div>
                  </div>
                </div>
                <div v-if="item.type == 'NTD' && item.ntdDetails && item.ntdDetails.length"
                     class="ntd-details-row">

                  <!-- Left label -->
                  <div class="ntd-details-label text-right font-weight-bold"
                       :class="addClass">
                    NTD Details:
                  </div>

                  <!-- Right bordered box -->
                  <div class="ntd-details-box">

                    <!-- WNTD Version row (top of box) -->
                    <div v-if="hasNtdVersionFor(panel.sq)" class="ntd-details-item">
                      <div class="ntd-details-name">NTD Version</div>
                      <div class="ntd-details-value">{{ ntdVersionFor(panel.sq) }}</div>
                    </div>

                    <!-- Detail rows -->
                    <div v-for="(subItem, index) in item.ntdDetails"
                         :key="index"
                         class="ntd-details-item">
                      <div class="ntd-details-name">{{ subItem.name }}</div>
                      <div class="ntd-details-value">{{ subItem.value }}</div>
                    </div>
                  </div>
                </div>
                <!-- Note under the list (still inside the box spacing) -->
                <div v-if="hasNtdVersionFor(panel.sq) && nbnOrder.productType === 'Fixed Wireless'" class="ntd-note">
                  <p>
                    <span class="ntd-note-label">Note:</span>
                    For customers with V1 or V2 WNTD, an appointment will be required to access High Speed Tiers
                  </p>
                </div>
              </div>
            </div>
            <div
              v-if="
                !isOldOrder &&
                  panel.sq &&
                  panel.sq.siteRestriction &&
                  panel.sq.siteRestriction.supportingProduct
              "
            >
              <div
                v-for="(item, index) in panel.sq.siteRestriction
                  .supportingProduct"
                :key="index"
                class="mt-4 pt-4 row-border"
              >
                <div class="pl-0 py-0">
                  <p
                    class="custom-p text-right font-weight-bold"
                    :class="addClass"
                  >
                    Product Id:
                  </p>
                  <p class="custom-p">
                    <span v-html="tier1"></span>{{ item.id }}
                  </p>
                </div>
                <div class="pl-0 py-0">
                  <p
                    class="custom-p text-right font-weight-bold"
                    :class="addClass"
                  >
                    Resource Details:
                  </p>
                  <p class="custom-p">
                    <span v-html="tier1"></span
                    >{{ parseResourceRef(item.resourceRef) }}
                  </p>
                </div>
              </div>
            </div>
            <div
              v-if="
                !isOldOrder &&
                  panel.sq &&
                  panel.sq.siteRestriction &&
                  panel.sq.siteRestriction.siteRestrictionError
              "
            >
              <div class="mt-5 pt-6 row-border">
                <div class="pl-0 py-0">
                  <p class="text-center text-error font-weight-bold">
                    {{
                      panel.sq.siteRestriction.siteRestrictionError.code
                    }}
                    -
                    {{
                      panel.sq.siteRestriction.siteRestrictionError
                        .message
                    }}
                  </p>
                </div>
              </div>
            </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  buildSqResultPanels,
  legacyNbnSqFields,
  nbnSqDisplayMode,
  nbnSqFailureMessage,
  sqRequestIncludesEe
} from "@/utils/nbnSqDisplay";

export default {
  name: "QualificationResultNbn",
  props: {
    showLocIdInput: { type: Boolean },
    showButtons: { type: Boolean },
    queryAddress: { type: Array },
    hideOtherButtons: { type: Boolean },
    selected: { type: String },
    hasMatch: { type: Boolean },
    wholesalerAccount: { type: Number },
    requireWholesalerSelection: { type: Boolean, required: false, default: false },
  },
  data: () => ({
    disableButton: false,
    result: {},
    locId: "",
    cad: "",
    potsInterconnect: "",
    serviceId: "",
    menu: false,
    newResult: null,
    tier1: "&nbsp;",
    tier2: "&nbsp;&nbsp;&nbsp;",
    tier3: "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
    tier4: "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;",
    sorting: -1,
    showSqResult: false,
    csaId: "",
    orderData: {},
    sqResponse: {},
    primaryAccessTechnology: "",
    serviceClass: [
      {
        class: "0",
        description:
          "Planned to be serviced by Fibre in the future (boundary status isn't 'In Service' yet)"
      },
      {
        class: "1",
        description: "Serviceable by Fibre, no drop or NTD in place"
      },
      {
        class: "2",
        description: "Serviceable by Fibre, drop in place, no NTD in place"
      },
      {
        class: "3",
        description: "Serviceable by Fibre, drop and NTD in place"
      },
      {
        class: "4",
        description: "Planned to be serviced by Wireless"
      },
      {
        class: "5",
        description: "Serviceable by Wireless, CPE not installed"
      },
      {
        class: "6",
        description: "Serviceable by Wireless, CPE installed"
      },
      {
        class: "7",
        description: "Planned to be serviced by Satellite"
      },
      {
        class: "8",
        description: "Serviceable by Satellite, Satellite - NTD not installed"
      },
      {
        class: "9",
        description: "Serviceable by Satellite, Satellite - NTD installed"
      },
      {
        class: "10",
        description: "Planned to be serviceable by Copper"
      },
      {
        class: "11",
        description: "Serviceable by copper, active node present"
      },
      {
        class: "12",
        description: "Serviceable by copper, jumpering is required"
      },
      {
        class: "13",
        description: "Serviceable by copper, infrastructure in place"
      },
      {
        class: "20",
        description:
          "Planned to be serviced by HFC, outside plant does not exist"
      },
      {
        class: "21",
        description:
          "Serviceable by HFC, the location has a street TAP but requires a lead-in, PCD, internal tie cable, and wall-plate/socket"
      },
      {
        class: "22",
        description:
          "Serviceable by HFC, the location has a street TAP, lead-in & PCD in place, but no internal tie-cables with wall plates/sockets"
      },
      {
        class: "23",
        description:
          "Serviceable by HFC, the location has a wall-plate/socket but no HFC NTD"
      },
      {
        class: "24",
        description:
          "Serviceable by HFC, Location has a wall-plate/socket & HFC NTD and is 'Ready to Connect'"
      },
      {
        class: "30",
        description: "Planned to be serviceable by FTTC"
      },
      {
        class: "31",
        description: "Serviceable by FTTC, no line available (RPU required)"
      },
      {
        class: "32",
        description: "Serviceable by FTTC, cut-in required (RPU required)"
      },
      {
        class: "33",
        description: "Serviceable by FTTC, cut-in complete (RPU required)"
      },
      {
        class: "34",
        description:
          "Serviceable by FTTC, infrastructure in place (Check RPU status)"
      }
    ],
    orderDetails: {
      accessTechnology: "",
      csaid: "",
      latitude: "",
      longitude: "",
      alternateTechnology: "",
      copperPairs: ""
    },
    addresses: []
  }),
  methods: {
    parseResourceRef(resource) {
      let resourceRef = resource[0];

      console.log("Raw resourceRef:", resourceRef);

      // Try to extract string from known property or fallback
      const refString =
        typeof resourceRef === "string"
          ? resourceRef
          : resourceRef?.value || "";

      if (!refString || typeof refString !== "string") {
        console.warn("Invalid or missing resourceRef string");
        return "Invalid resource";
      }

      const regex = /id\['((NTD|CPI)\d+)'\](?:\/uniPortD\/id\['([^']+)'\])?/;
      const match = refString.match(regex);

      if (!match) {
        console.warn("No regex match for:", refString);
        return "Unmatched format";
      }

      const mainId = match[1];
      const uniId = match[3];

      return uniId ? `${mainId} / ${uniId}` : mainId;
    },
    clearLocId() {
      let vm = this;
      vm.setLocationID("");
      vm.setSqResult({});
      vm.resetFormattedSQResult();
    },
    locationText(val) {
      if (val.addressSiteName) {
        return `${val.formattedAddress} (${val.addressSiteName} - ${val.locationId})`;
      } else {
        return `${val.formattedAddress} (${val.locationId})`;
      }
    },
    createOrder() {
      let vm = this;

      if (vm.orderType === "5g") {
        if (vm.sq5gResult.location) {
          let payload = {
            msisdn: "",
            sectorID: "",
            techType: "5G",
            uploadSpeed: "10",
            downloadSpeed: "50"
          };

          vm.sq5gResult.location.forEach(x => {
            x.mobileQualification.serviceSpecCharacteristics.forEach(y => {
              if (y.name === "SectorID") payload.sectorID = y.value;
            });
          });

          vm.$emit("createOrder", {
            withData: true,
            payload: payload
          });
        }
      } else {
        let streetNrFirst = "",
          streetNrLast = "",
          streetName = "",
          streetType = "",
          suburb = "",
          postcode = "",
          stateOrProvince = "",
          longitude = "",
          latitude = "",
          formattedAddress = "",
          lotNumber = "";

        vm.result.address.additionalParameters.forEach(x => {
          switch (x.name) {
            case "streetNrFirst":
              streetNrFirst = x.value;
              break;
            case "streetNrLast":
              streetNrLast = x.value;
              break;
            case "streetName":
              streetName = x.value;
              break;
            case "streetType":
              streetType = x.value;
              break;
            case "suburb":
              suburb = x.value;
              break;
            case "postcode":
              postcode = x.value;
              break;
            case "stateOrProvince":
              stateOrProvince = x.value;
              break;
            case "longitude":
              longitude = x.value;
              break;
            case "latitude":
              latitude = x.value;
              break;
            case "formattedAddress":
              formattedAddress = x.value;
              break;
            case "lotNumber":
              lotNumber = x.value;
              break;
          }
        });

        let address = {
          streetNrFirst: streetNrFirst,
          streetNrLast: streetNrLast,
          streetName: streetName,
          streetType: streetType,
          suburb: suburb,
          postcode: postcode,
          stateOrProvince: stateOrProvince,
          longitude: longitude,
          latitude: latitude,
          locationId: vm.locationId,
          formattedAddress: vm.newAddress || formattedAddress,
          lotNumber: lotNumber
        };

        vm.$emit("createOrder", {
          withData: true,
          address: address,
          sqResult: vm.result,
          locationId: vm.locationID
        });
      }
    },

    updateLocationId() {
      let vm = this;
      vm.setLocationID(vm.nbnOrder.locationId);
      vm.resetData();
    },
    resetData() {
      let vm = this;
      vm.hideResult();
      vm.setLocationID(vm.nbnOrder.locationId);
      vm.resetProduct();
      vm.setFibreCheckbox(false);
    },
    getPortNumber(data) {
      const id = data && data.id != null ? String(data.id) : "";
      return `Port ${id.substring(Math.max(id.length - 1, 0))}`;
    },
    hideResult() {
      let vm = this;
      vm.result = {};
      vm.reset5gSq();
      vm.showSqResult = false;
      vm.$emit("hideBaseOffer");
    },

    createEmail() {
      let vm = this;
      vm.createTemplatedEmail().then(() => {
        //
      });
    },
    runNBNSQ() {
      let vm = this;
      let payload = {};

      if (vm.requireWholesalerSelection) {
        const wholesalers = vm.wholesalers ?? [];
        const first = (arr) => (arr && arr.length ? arr[0] : null);

        const setFromEmail = (email) => {
          const match = first(wholesalers.filter(x => x.oneLoginEmail === email));
          vm.wholesalerAccount = match ? match.accountNumber : vm.wholesalerAccount;
        };

        if (vm.impersonating !== null) {
          if (vm.isUserMember) {

            if (wholesalers.length > 1) {
              vm.wholesalerAccount = vm.wholesalerAccount > 0 ? vm.wholesalerAccount : 0;
            } else {
              vm.wholesalerAccount = wholesalers[0].accountNumber;
            }
          } else {
            setFromEmail(vm.impersonating.impersonateEmail);
          }
        } else {
          if (vm.isAdmin) {

            const match = first(
              wholesalers.filter(x => x.accountNumber === vm.selectedOrder.wholesalerAccountNumber)
            );

            vm.wholesalerAccount = match ? match.accountNumber : vm.wholesalerAccount;
          } else {
            setFromEmail(vm.user.email);
          }
        }
        if (!vm.wholesalerAccount || vm.wholesalerAccount === 0) {
          vm.setHttpResponse?.({ text: "Please select a Wholesaler.", color: "error" });
          return;
        }
      }

      vm.resetData();
      vm.setOrderType("nbn");

      vm.resetHasNtd();
      let data = {};
      let methodType = "";

      methodType = "NBN_LOCATION_ID";
      data = { LocationId: vm.nbnOrder.locationId };

      payload = {
        addressCheckMethodType: methodType,
        addressValue: data
      };

      if (vm.cad !== "") {
        payload.cad = vm.cad;
      }

      if (vm.serviceId !== "") {
        payload.avcId = vm.serviceId;
      }

      if (vm.potsInterconnect !== "") {
        payload.pots = vm.potsInterconnect;
      }

      if (sqRequestIncludesEe(vm.$route && vm.$route.path, vm.isNbnEeAdmin)) {
        payload.includeEe = true;
      }

      vm.serviceQualificationNbn(payload).then(data => {
        const result = data && data.data;
        const site = result && result.sq;
        const onSqPage = nbnSqDisplayMode(vm.$route && vm.$route.path) === "both";
        if (!site || !site.siteRestriction) {
          if (!onSqPage) {
            vm.showSqResult = false;
            if (!data || data.success !== false) {
              vm.setHttpResponse({
                text: nbnSqFailureMessage(data),
                color: "error"
              });
            }
            return;
          }
          vm.setFormattedNbnSQResult(result || {});
          vm.result = result || {};
          vm.showSqResult = true;
          return;
        }
        vm.showSqResult = true;
        vm.setFormattedNbnSQResult(result);
        vm.result = result;
        const orderPayload = result;
        const technology =
          (site.siteRestriction && site.siteRestriction.supportingTechnology) ||
          {};
        vm.setProductType(technology.primaryAccessTechnology || "");
        vm.setNtdId(orderPayload);
        vm.setNtdType(orderPayload);
        vm.setCpiId(orderPayload);

        if (vm.requireWholesalerSelection) {

          var search = {
            keyword: null,
            wholesalerAccountNumber: vm.wholesalerAccount
          };

          vm.searchOrganisationsAsync(search)
            .then(data => {
              vm.parties = [];
              data.data.forEach(x => {
                vm.parties.push({
                  text: x.businessName + "(" + x.partyId + ")",
                  value: x.partyId,
                  disabled: false
                });
              });
              vm.$emit("partiesLoaded", vm.parties);
            });
        }

        vm.$emit("showResultSection", result);
        vm.result = result;
      });
    },
    cancel() {
      let vm = this;
      vm.result = {};
      vm.setLocationID("");
      vm.setAddressQueryResult({});
      vm.$emit("cancel");
    },
    copyText(key) {
      let vm = this;
      const ref = vm.$refs["sqResult-" + key];
      const element = Array.isArray(ref) ? ref[0] : ref;
      if (!element) return;
      vm.selectText(element);
      document.execCommand("copy");
    },
    ntdVersionFor(sq) {
      const resource = sq && sq.siteRestriction && sq.siteRestriction.supportingResource;
      if (!resource || !Array.isArray(resource) || resource.length === 0) return "";
      const selected =
        resource.find(x => x && x.id === this.nbnOrder.ntdId) || resource[0];
      return (selected && selected.NTDVersion) || "";
    },
    hasNtdVersionFor(sq) {
      const isSog8191Enabled = this.featureFlags && this.featureFlags.sog8191;
      if (!isSog8191Enabled && this.nbnOrder.productType !== "Fixed Wireless") {
        return false;
      }
      const validVersions = isSog8191Enabled
        ? ["V1", "V2", "V3", "V4"]
        : ["V1", "V2"];
      const resource = sq && sq.siteRestriction && sq.siteRestriction.supportingResource;
      return (
        Array.isArray(resource) &&
        resource.length > 0 &&
        resource[0] &&
        resource[0].NTDVersion &&
        validVersions.includes(this.ntdVersionFor(sq))
      );
    },
    panelBorderClass(panel) {
      if (panel.empty) return "";
      if (this.isOriginal || panel.serviceable) return "serviceable";
      return "not-serviceable";
    },
    eeRows(section) {
      return ((section && section.rows) || []).filter(row => row.value !== "");
    },
    selectText(element) {
      var range;
      if (document.selection) {
        document.create;
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },
    setValue(item, serviceability) {
      if (!item) {
        const fields = legacyNbnSqFields(this.sqNbnResult);
        this.orderDetails.accessTechnology = fields.accessTechnology;
        this.orderDetails.csaid = fields.csaid;
        this.orderDetails.latitude = fields.latitude;
        this.orderDetails.longitude = fields.longitude;
        return fields.serviceabilityClass || "";
      }
      if (!serviceability) {
        return `${item} - ${this.setDescription(item)}.`;
      }
      return `${item} - ${serviceability}. ${this.setDescription(item)}.`;
    },
    setDescription(item) {
      let vm = this;
      let description = "";
      vm.serviceClass.forEach(x => {
        if (x.class === item) description = x.description;
      });

      return description;
    },
    updateLocId() {
      let vm = this;
      vm.setLocationID(vm.nbnOrder.locationId);
      vm.setFibreCheckbox(false);
    },
    showSection(data, type) {
      if (data[type] !== undefined) return true;
      else return false;
    },
    showDetails(data, types) {
      let vm = this;
      let show = false;
      types.forEach(x => {
        if (vm.showSection(data, x)) show = true;
      });
      return show;
    },
    disableSqButton(disable) {
      let vm = this;
      if (disable) vm.disableButton = true;
      else vm.disableButton = false;
    },
    showAddresses(data) {
      let vm = this;
      vm.hasMatch = true;
      vm.addresses = data.data;
    },
    getAddressParam(name) {
      const vm = this;
      const addr = vm.sqNbnResult.address;
      if (!addr) return "";
      if (addr[name] != null && addr[name] !== "") return addr[name];
      if (Array.isArray(addr.additionalParameters)) {
        const match = addr.additionalParameters.find(x => x.name === name);
        return match ? match.value : "";
      }
      return "";
    }
  },
  computed: {
    sqDisplayMode() {
      return nbnSqDisplayMode(this.$route && this.$route.path);
    },
    sqResultPanels() {
      return buildSqResultPanels(this.sqNbnResult, {
        showEe: sqRequestIncludesEe(
          this.$route && this.$route.path,
          this.isNbnEeAdmin
        ),
        showEmpty: this.sqDisplayMode === "both"
      });
    },
    invalidProductErr() {
      let vm = this;
      return vm.$route.path === "/"
        ? `${vm.primaryAccessTechnology} is not included in our services. Can't proceed with the order.`
        : `${vm.primaryAccessTechnology} is not included in our services.`;
    },
    isEnhancedTransfer() {
      let vm = this;
      if (vm.selected === "Enhanced SQ - Service Transfer") {
        return true;
      } else {
        return false;
      }
    },
    isTransferReady() {
      let vm = this;
      if (vm.cad !== "" && vm.serviceId !== "") {
        return true;
      } else {
        return false;
      }
    },
    isEnhancedTransition() {
      let vm = this;
      if (vm.selected === "Enhanced SQ - Service Transition") {
        return true;
      } else {
        return false;
      }
    },
    sortedQueryAddress() {
      let vm = this;
      var result = null;

      if (vm.queryAddress.length > 0) result = vm.queryAddress;
      else result = vm.addresses;

      return result
        .slice(0)
        .sort((a, b) =>
          parseInt(a.lotNumber) < parseInt(b.lotNumber) ||
          parseInt(a.subUnitNr) < parseInt(b.subUnitNr) ||
          parseInt(a.streetNrFirst) < parseInt(b.streetNrFirst) ||
          parseInt(a.streetName) < parseInt(b.streetName)
            ? this.sorting
            : -this.sorting
        );
    },
    secondaryAddressText() {
      const vm = this;
      if (!vm.sqNbnResult.address) return "";
      const secondaryComplexName = vm.getAddressParam("secondaryComplexName");
      const addressSiteName = vm.getAddressParam("addressSiteName");
      const complexBase = secondaryComplexName || addressSiteName;
      const levelTypeCode =
        vm.getAddressParam("levelTypeCode") || vm.getAddressParam("leveltypeCode");
      const levelNumber = vm.getAddressParam("levelNumber");
      const hasLevel = levelTypeCode === "L" && !!levelNumber;
      if (!complexBase && !hasLevel) return "";
      const parts = [];
      if (hasLevel) parts.push(`Level ${levelNumber}`);
      if (complexBase) parts.push(complexBase);
      if (secondaryComplexName && addressSiteName) parts.push(addressSiteName);
      return parts.join(", ");
    },
    newAddress() {
      const vm = this;
      if (vm.sqNbnResult.address) {
        let address = "";
        if (!vm.sqNbnResult.address.formattedAddress) {
          const parameters = vm.sqNbnResult.address.additionalParameters || [];
          parameters.forEach(x => {
            if (x.name === "formattedAddress") address = x.value;
          });
        } else {
          address = vm.sqNbnResult.address.formattedAddress;
        }
        const secondary = vm.secondaryAddressText;
        if (secondary) {
          address += ` (${secondary})`;
        }
        return address;
      } else return "";
    },
    firstColumn() {
      let vm = this;
      if (vm.$route.path === "/") return "5";
      else return "4";
    },
    secondColumn() {
      let vm = this;
      if (vm.$route.path === "/") return "7";
      else return "8";
    },
    addClass() {
      let vm = this;
      if (
        vm.$route.path === "/" ||
        vm.$route.path === "/nbn-orders" ||
        vm.$route.path === "/nbn-active-orders"
      )
        return "first-order";
      else return "first-sq";
    },
    disableOnLookup() {
      let vm = this;
      return vm.selected === "Location ID" || vm.selected === "Geocode";
    },
    showNbnButton() {
      let vm = this;

      if (vm.$route.path === "/") {
        return vm.orderType === "nbn";
      } else return true;
    },
    show5GButton() {
      let vm = this;

      if (vm.$route.path === "/") {
        return vm.orderType === "5g";
      } else return true;
    },
    buttonColSize() {
      let vm = this;
      if (vm.$route.path === "/") return "3";
      else return "2";
    },
    fieldColSize() {
      let vm = this;
      if (vm.$route.path === "/") return "9";
      else return "10";
    }
  },
  watch: {
    locationID: function() {
      let vm = this;
    },
    locId: function() {
      let vm = this;
      vm.resetData();
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-div {
  border: 2px solid #9e9e9e;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 15px;
  font-size: 15px !important;
}

.serviceable {
  border-color: #2cd375 !important;
}

.not-serviceable {
  border-color: #ee3923 !important;
}

.row-border {
  border-top: 1px solid #9e9e9e;
}

.custom-p {
  display: inline-block;
  margin-bottom: 2px;
}

.first-sq {
  width: 513px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: top;
}

.first-order {
  width: 445px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: top;
  width: 37%;
}

.text-error {
  color: #ee3923;
}

.text-matched {
  color: #2cd375;
}
  .ntd-details-row {
    display: flex;
    align-items: flex-start;
    margin: 10px 0;
  }

  .ntd-details-label {
    min-width: 250px; /* aligns like the screenshot */
    padding-right: 14px;
    line-height: 1.2;
  }

  .ntd-details-box {
    padding: 1px 12px;
    display: inline-block;
    min-width: 470px; /* adjust if you want wider/narrower */
  }

  .ntd-details-item {
    display: flex;
    align-items: baseline;
    line-height: 1.6;
  }

  .ntd-details-name {
    width: 160px; /* matches your old width */
  }

  .ntd-details-value {
    flex: 1;
    word-break: break-word;
  }

  .ntd-note {
    grid-column: 1 / -1;
    margin-top: 6px;
    white-space: normal;
    justify-self: center; /* center within grid */
    max-width: 700px; /* optional: prevent super-wide line */
  }

  .ntd-note p {
    margin: 0;
    white-space: normal;
    word-break: break-word;
  }

  .ntd-note-label {
    color: red;
    font-weight: 600;
  }
@media screen and (max-width: 1100px) {
  .custom-div {
    width: 1100px;
  }
}
</style>
